import React, { Component, Fragment } from 'react'
import RestaurantSummary from '../restaurants/RestaurantSummary'
import { connect } from 'react-redux'
import { isTagged, isTaggedAny } from '../restaurants/Tags'
import { sortRestaurants, updateSortOptions, updatePlayerChoices } from '../../store/actions/restaurantActions'
import Masonry from 'react-masonry-css'
import AdSummary from "../ads/AdSummary";
import { Redirect } from 'react-router-dom'

class ChooseRestaurantList extends Component {

  constructor (props){
    super(props);
    this.state = {
    allContent: this.props.sortOptions.allContent,
    newProjects: [],
    test:true,
    showNumber:10
    }
  this.handleScroll = this.handleScroll.bind(this);
  }

  
  componentDidMount(){
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount(){
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll = ()=>{
    let a = 'test';
    let b = 'test';
    if(document.getElementById("container")){
      a = document.getElementById("container").scrollHeight
      b = window.pageYOffset;
    }
    console.log(a-b)
    if(this.props.restaurant.newProjects && (a-b) < 800 && this.props.restaurant.newProjects.length > this.state.showNumber){
      console.log('trigger')
      this.setState({showNumber:this.state.showNumber + 20})

    }
  }

  componentDidUpdate(){

    if(this.props.sortOptions.allContent !== this.state.allContent){
      this.setState({allContent:this.props.sortOptions.allContent})
    }

    if(this.props.projects && this.props.sortOptions !== undefined && this.props.distanceList !== undefined && this.props.distanceList !== {}
      && this.props.favorites){
      var proj = [];
      for(var entry in Object.entries(this.props.projects)){
        proj.push(Object.entries(this.props.projects)[entry][1]);
      }
      var newProjects = proj;
      if (this.props.sortOptions.sortFavorites){
        newProjects = newProjects.filter(project => (project.restaurantId in this.props.favorites[this.props.auth.uid] && this.props.favorites[this.props.auth.uid][project.restaurantId] === true ))
      }
      

      if (this.props.sortOptions.sortOnlineNotMenu){
        newProjects = newProjects.filter(project => (project.orderUrl !== "" ))
      }

      if (!this.props.sortOptions.sortPickup){
        newProjects = newProjects.filter(project => (!project.pickupOnly))
      }
      
      if(this.props.sortOptions.sortTags && this.props.sortOptions.sortTags.length>0){
        if (this.props.sortOptions.anyTags){
         newProjects = newProjects.filter(project => (isTaggedAny(project, this.props.sortOptions.sortTags) ))
        }
        else{
          newProjects = newProjects.filter(project => (isTagged(project, this.props.sortOptions.sortTags) ))
        }
      }

      if (this.props.sortOptions.sortOpen && this.props.sortOptions.openList && !this.isEmpty(this.props.sortOptions.openList)){
       newProjects = newProjects.filter(project => (this.openFinder(project)))
      }


      if(this.props.sortOptions.sortDistance && !this.isEmpty(this.props.distanceList)){
        var sortDistanceList = [];
        for(var project in newProjects){
          if(newProjects[project] !== null){
            sortDistanceList.push([newProjects[project], this.props.distanceList[newProjects[project].restaurantId]])
          }
        }
        sortDistanceList.sort(function(a, b) {
         return a[1] - b[1];
        });
        var newProjects2=[];
        for(project in sortDistanceList){
          newProjects2.push(sortDistanceList[project][0])
        }
        newProjects=newProjects2;
      }

      if(this.props.sortOptions && this.props.sortOptions.sortName && JSON.stringify(this.props.sortOptions.sortName) !== JSON.stringify([])
        && this.props.sortOptions.sortName !== ''){
        var sortNameProjects = [];
        for(var name of this.props.sortOptions.sortName){
          sortNameProjects.push(newProjects.filter(project => (project.name === name.value))[0]);
        }
        newProjects = sortNameProjects;
        if(JSON.stringify(this.state.newProjects)!==JSON.stringify(newProjects)){
          this.setState({newProjects:newProjects}); 
        }
      }
      
      if(newProjects){
      var filtered = newProjects.filter(function(x) {
           return x !== undefined;
      });
      newProjects = filtered;
      var numOfRestaurants = newProjects.length;
      }

      var reduxList = [];
      var newList = [];
      for (var item in this.props.restaurant.newProjects){
        reduxList.push(this.props.restaurant.newProjects[item].id);
      }
      for (var otherItem in newProjects){
        if(newProjects[otherItem] !== null){
          newList.push(newProjects[otherItem].id);
        }
      }


      if (JSON.stringify(reduxList)!==JSON.stringify(newList) && !this.isEmpty(this.props.distanceList)){
        this.setState({newProjects:newProjects})
        this.props.sortRestaurants(newProjects);
      }


      if(this.state.numOfRestaurants !== numOfRestaurants){
        this.setState({numOfRestaurants:numOfRestaurants})
      }

      
    }    

  }

  isEmpty = (object) => {
    for(let key in Object.keys(object)){
      return false;
    }
    return true;
  }

  onFavorite = this.props.onFavorite;
  
  openFinder = (project) => {
    //console.log(Object.keys(this.props.sortOptions.openList));
    for(let key in Object.keys(this.props.sortOptions.openList)){
      // console.log(key);
      // console.log(this.props.sortOptions.openList[key]['id']);
        if (project.restaurantId === this.props.sortOptions.openList[key]['id'] && this.props.sortOptions.openList[key]['isOpen']){
          //console.log(this.props.sortOptions.openList[key]['opensAt']);
          return(true);
        }
      }

    return(false)

  }

  opensAtFinder = (project) => {
    //console.log(Object.keys(this.props.sortOptions.openList));
    for(var key2 in this.props.sortOptions.openList){
      //console.log(key2);
      //console.log(this.props.sortOptions.openList[key2]['id']);
        if (project.restaurantId === this.props.sortOptions.openList[key2]['id']){
          return(this.props.sortOptions.openList[key2]['opensAt']);
        }
      }
      return("error");
        
  }

  handleReset=()=>{
    var sortOptions = this.props.restaurant.sortOptions;
    sortOptions.sortTags = "";
    sortOptions.sortName = "";
    sortOptions.sortCombined = "";
    sortOptions.sortPickup = true;
    sortOptions.sortOnlineNotMenu = false;
    sortOptions.sortOpen = false;
    sortOptions.sortDistance = true;
    sortOptions.sortFavorites = false;
    this.props.updateSortOptions(sortOptions);
  }
  
  handleAll=()=>{
    this.setState({showNumber:this.props.projects.length})
  }

  handleChoose=(restaurantId, gameId, choice, userId)=>{
    console.log('choose');
    console.log(restaurantId);
    console.log(gameId);
    console.log(choice);
    console.log(userId);
    console.log('games');
    console.log(this.props.games);
    let prevChoices = [];
    prevChoices = [...this.props.games[gameId]['playerChoices'][userId]];
    prevChoices[choice] = restaurantId;
    console.log(prevChoices);
    if(!this.state.noChoice){
      this.setState({noChoice:true});
      console.log('newChoices');
      console.log(prevChoices);
      this.props.updatePlayerChoices(restaurantId, gameId, choice, userId, prevChoices,
        ()=>{this.setState({"redirect":true})}
        );  
    }
  }

  distFinder=(restaurantId, distanceList)=>{
      const entries = Object.entries(distanceList);
      for (const entry of entries){
        if (entry[0] === restaurantId)
        return entry[1]
      }
      return ""
    };

  render(){
    const { favorites, distanceList } = this.props;

    let prevChoices2 = [];
    prevChoices2 = [...this.props.games[this.props.gameId]['playerChoices'][this.props.firebase.auth.uid]];
    console.log('previous choices');
    console.log(prevChoices2)


    if(this.state.redirect){
      return <Redirect to={'/gameInProgress/'+ this.props.gameId} />
    }
    const breakpointColumnsObj = {
        default: 3,
        1275: 2,
        950: 1
      
      };

    var jsxElements = <div key="loading"><p>loading</p></div>;

    if(this.props.games && this.props.restaurant.newProjects && this.props.sortOptions.openList && distanceList){
    jsxElements = this.props.restaurant.newProjects.map((project, index) => {
        if(!prevChoices2.includes(project.restaurantId)){
          if(index !== 6 && index !== 24 && index !== (this.props.restaurant.newProjects.length - 1)){
            return (
              <div key = { project.restaurantId }>
                <RestaurantSummary isOpen = {this.openFinder(project)} opensAt = {this.opensAtFinder(project)} distance = {this.distFinder(project.restaurantId, distanceList)} onFavorite = {this.onFavorite} project={project} allContent = {this.state.allContent} favorite = {(project.restaurantId in {...favorites} && favorites[project.restaurantId].favorite === true )}/>
                {!this.state.noChoice &&
                <div className="input-field" style={{"display": "flex", "justifyContent": "center"}}>
                  <button className="btn pink lighten-1" onClick={()=>{this.handleChoose(project.restaurantId, this.props.gameId, this.props.choice, this.props.firebase.auth.uid)}}>Choose</button>
                </div>
                }   
              </div>              
            )  
          }
          else if(window.innerWidth < 715 && index === this.props.restaurant.newProjects.length - 1){
            return(
              <Fragment key = {'finalAd'}>
                <div key = { project.restaurantId }>
                  <RestaurantSummary isOpen = {this.openFinder(project)} opensAt = {this.opensAtFinder(project)} distance = {this.distFinder(project.restaurantId, distanceList)} onFavorite = {this.onFavorite} project={project} allContent = {this.state.allContent} favorite = {(project.restaurantId in {...favorites} && favorites[project.restaurantId].favorite === true )}/>
                  {!this.state.noChoice &&
                  <div className="input-field" style={{"display": "flex", "justifyContent": "center"}}>
                    <button className="btn pink lighten-1" onClick={()=>{this.handleChoose(project.restaurantId, this.props.gameId, this.props.choice, this.props.firebase.auth.uid)}}>Choose</button>
                  </div>
                  }
                </div>
                <AdSummary adInformation = {0} key = { project.restaurantId + 'finalad' }/>
              </Fragment>  
            )
          }
          else if(window.innerWidth < 715 && index === 6){
           return (
            <Fragment key = {'ad' + index}>
              <div key = { project.restaurantId }>
                <RestaurantSummary isOpen = {this.openFinder(project)} opensAt = {this.opensAtFinder(project)} distance = {this.distFinder(project.restaurantId, distanceList)} onFavorite = {this.onFavorite} project={project} allContent = {this.state.allContent} favorite = {(project.restaurantId in {...favorites} && favorites[project.restaurantId].favorite === true )}/>
                {!this.state.noChoice &&
                <div className="input-field" style={{"display": "flex", "justifyContent": "center"}}>
                  <button className="btn pink lighten-1" onClick={()=>{this.handleChoose(project.restaurantId, this.props.gameId, this.props.choice, this.props.firebase.auth.uid)}}>Choose</button>
                </div>
                }
              </div>
              <AdSummary adInformation = {2} adNumber= {1} key = { project.restaurantId + 'ad'}/>
            </Fragment>
            ) 
          }
          else if(window.innerWidth < 715){
           return (
            <Fragment key = {'ad' + index}>
              <div key = { project.restaurantId }>
                <RestaurantSummary isOpen = {this.openFinder(project)} opensAt = {this.opensAtFinder(project)} distance = {this.distFinder(project.restaurantId, distanceList)} onFavorite = {this.onFavorite} project={project} allContent = {this.state.allContent} favorite = {(project.restaurantId in {...favorites} && favorites[project.restaurantId].favorite === true )}/>
                {!this.state.noChoice &&
                <div className="input-field" style={{"display": "flex", "justifyContent": "center"}}>
                  <button className="btn pink lighten-1" onClick={()=>{this.handleChoose(project.restaurantId, this.props.gameId, this.props.choice, this.props.firebase.auth.uid)}}>Choose</button>
                </div>
                }
              </div>
              <AdSummary adInformation = {1} key = { project.restaurantId + 'ad'}/>
            </Fragment>
            ) 
          }
          else{
            return(
              <div key = { project.restaurantId }>
                <RestaurantSummary isOpen = {this.openFinder(project)} opensAt = {this.opensAtFinder(project)} distance = {this.distFinder(project.restaurantId, distanceList)} onFavorite = {this.onFavorite} project={project} allContent = {this.state.allContent} favorite = {(project.restaurantId in {...favorites} && favorites[project.restaurantId].favorite === true )}/>
                {!this.state.noChoice &&
                <div className="input-field" style={{"display": "flex", "justifyContent": "center"}}>
                  <button className="btn pink lighten-1" onClick={()=>{this.handleChoose(project.restaurantId, this.props.gameId, this.props.choice, this.props.firebase.auth.uid)}}>Choose</button>
                </div>
                }
              </div>
            )
          }
          } 
          });
      if(window.innerWidth > 714 ){
        jsxElements.push(<AdSummary adInformation = {0} key = { 'finalad' }/>)  
      }
    }

  return(
    <div>
    { !this.state.noChoice &&
      <div>
        <p style={{"textAlign":"center"}}> { this.state.numOfRestaurants } restaurants found</p>
        { this.props.restaurant && this.props.restaurant.sortOptions && ((this.props.restaurant.sortOptions.sortTags !== "" && JSON.stringify(this.props.restaurant.sortOptions.sortTags) !== "[]") || (this.props.restaurant.sortOptions.sortName !== "" && JSON.stringify(this.props.restaurant.sortOptions.sortName) !== "[]")
          || !this.props.restaurant.sortOptions.sortPickup || this.props.restaurant.sortOptions.sortOnlineNotMenu || this.props.restaurant.sortOptions.sortOpen || !this.props.restaurant.sortOptions.sortDistance || this.props.restaurant.sortOptions.sortFavorites) &&
          <div className="input-field" style={{"display": "flex", "justifyContent": "center"}}>
            <button className="btn pink lighten-1" onClick={this.handleReset}>Reset</button>
          </div>
        }
        <div className="container-test2" id="container">
          <Masonry
            breakpointCols={breakpointColumnsObj}
            className="my-masonry-grid"
            columnClassName="my-masonry-grid_column">
              { this.props.restaurant.newProjects && this.props.sortOptions.openList && distanceList && jsxElements.slice(0,this.state.showNumber)
            }
          </Masonry>
          { this.props.restaurant && this.props.restaurant.newProjects && this.props.restaurant.newProjects.length > this.state.showNumber &&
            <div className="input-field" style={{"display": "flex", "justifyContent": "center"}}>
              <button className="btn pink lighten-1" onClick={this.handleAll}>Show All</button>
            </div>
          }
        </div>
      </div>
    }
    { this.state.noChoice &&
      <p style={{"textAlign":"center"}}> Redirecting...</p>
    }
    </div>
    )
    
  
}
}

const mapStateToProps = (state) => {
  return {
    ...state,
    auth: state.firebase.auth,
    projects: state.firestore.data.restaurants,
    restaurant: state.restaurant,
    games: state.firestore.data.games
  }
}

const mapDispatchToProps = dispatch => {
  return {
    sortRestaurants: (newProjects) => dispatch(sortRestaurants(newProjects)),
    updateSortOptions: (state) => dispatch(updateSortOptions(state)),
    updatePlayerChoices: (restaurantId, gameId, choice, userId, newChoices, callback) => dispatch(updatePlayerChoices(restaurantId, gameId, choice, userId, newChoices, callback))
  }
}



export default connect(mapStateToProps, mapDispatchToProps)(ChooseRestaurantList)